export default __webpack_public_path__ + "static/media/clientCase1.cfb248dd.png";